import { Button } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import List from 'src/components/grid.component/index'
import { AddresssHandler, AmountHandler, CreditHandler, DateHandler, TransactionHash } from './service';
import TopUpTransactions from './topUpTransactions';
import { useParams } from 'react-router-dom';
const RecentTopup = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { tenantId } = useParams()

  const gridRef = useRef(null);
  const { isTopupGridRefresh, setIsTopupGridRefresh } = props?.GridRefreshData;
  useEffect(() => {
    gridRef?.current?.refreshGrid();
    setIsTopupGridRefresh(false);
  }, [isTopupGridRefresh]);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsModalVisible(false);
  }, [])
  const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const topupTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const amountHandler = useCallback((data) => {
    return <AmountHandler data={data?.dataItem} />
  }, [])

  const refreshCallBack = useCallback(() => {
    setIsTopupGridRefresh(false);
  }, []);
  const gridColumns = [
    {
      "field": "transactionhash",
      "title": "Transaction Hash",
      "filter": true,
      "customCell": topupTransactionHandler,
      "width": 200
    },
    {
      "field": "credits",
      "title": "Credit",
      "customCell": creditHandler,
      "filter": true,
      "width": 150,
      "filterType": "numeric"
    },
    {
      "field": "date",
      "title": "Date/Time",
      "filter": true,
      "width": 200,
      "filterType": "date",
      "customCell": dateHandler
    },
    {
      "field": "address",
      "title": "Address",
      "customCell": addressHandler,
      "filter": true,
      "width": 200
    },
    {
      "field": "currency",
      "title": "Currency",
      "filter": true,
      "width": 150
    },
    {
      "field": "amount",
      "title": "Amount",
      "customCell": amountHandler,
      "filter": true,
      "width": 150,
      "filterType": "numeric"
    }
  ]
  return (
    <div className='mt-5'>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="main-title text-capitalize">
          Recent Topup
        </h2>
        <Button type="default" className=" cancel-btn px-4 !h-auto" onClick={showModal}>
          See All
          <span className="icon icon-arrow-right ml-2"></span>
        </Button>
        {isModalVisible && <TopUpTransactions visible={isModalVisible} onClose={handleClose} />}
      </div>
      <List
        url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/Topupk/${tenantId}/null/null/null`}
        pSize={5}
        className="custom-grid"
        pageable={false}
        screenName={'Energy_TopUp_Transactions'}
        columns={gridColumns}
        refresh={isTopupGridRefresh}
        refreshCallBack={refreshCallBack}
        ref={gridRef}
      />
    </div>
  );
}

export default RecentTopup;